var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.columnData.score)?_c('div',{staticClass:"icon-speed",class:'icon-speed--' + _vm.columnData.score},[_vm._v("IRL Score: "+_vm._s(_vm.columnData.score)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }